import React from "react";
import {
  getFormattedDateString,
  formatTime,
  hasPermission,
} from "utility/helpers";
import { attendanceStatusSelectStyles } from "constants/style";
import CustomSelect from "components/customs/dropdown";
import { UncontrolledTooltip } from "reactstrap";
import styled from "styled-components";
import { ATTENDANCE_STATUS_OPTIONS } from "constants/status";
import {
  AddCommentBtn,
  CellText,
  StyledEyeIcon,
  ViewCommentBtn,
} from "assets/js/Styles";
import { VIEW_ACTION } from "constants/actions";

const CommentsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  position: relative;

  &:has(.unread-msgs) {
    bottom: 10px;
  }
`;

const StyledCustomSelect = styled(CustomSelect)`
  .select__control:has(.invited-status) {
    background-color: #00316d;
    border: none;
    .invited-status {
      color: white;
    }
  }

  .select__control:has(.confirmed-status) {
    background-color: #53a24c;
    border: none;
    .confirmed-status {
      color: white;
    }
  }

  .select__control:has(.declined-status) {
    background-color: #df3348;
    border: none;
    .declined-status {
      color: white;
    }
  }

  .select__control:has(.no-response-status) {
    background-color: #ffbd14;
    border: none;
  }

  .select__control:has(.attended-status) {
    background-color: #265ea3;
    border: none;
    .attended-status {
      color: white;
    }
  }

  .select__control:has(.did-not-attend-status) {
    background-color: #e1700d;
    border: none;
    .did-not-attend-status {
      color: white;
    }
  }
`;

const eventColumns = ({
  handleStatusChange,
  getStatusOptions,
  isRoleCongressman,
  navigate,
  fetchComments,
  setCommentId,
  toggleModal,
  id,
  congDetails,
  congID,
}) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "Event Name",
      selector: (eventName) => eventName,
      identifier: "eventName",
      grow: 3,
      sortable: true,
      cell: ({ eventName }) => <CellText>{eventName}</CellText>,
    },
    {
      name: "Date Period",
      selector: (Event) => Event,
      identifier: "eventStartDate",
      grow: 2,
      sortable: true,
      cell: ({ eventStartDate, eventEndDate }) => (
        <CellText>
          {getFormattedDateString(eventStartDate, "MMM dd, yyyy")}
          {" - "}
          {getFormattedDateString(eventEndDate, "MMM dd, yyyy")}
        </CellText>
      ),
    },
    {
      name: "Time",
      selector: (Event) => Event,
      identifier: "eventStartTime",
      grow: 2,
      sortable: true,
      cell: ({ eventStartTime, eventEndTime }) => (
        <CellText>
          {formatTime(eventStartTime)}
          {" - "}
          {formatTime(eventEndTime)}
        </CellText>
      ),
    },
    {
      name: "Venue",
      selector: (eventVenue) => eventVenue,
      identifier: "eventVenue",
      grow: 3,
      sortable: true,
      cell: ({ eventVenue }) => <CellText>{eventVenue}</CellText>,
    },
    {
      name: "Status",
      selector: (eventParticipantStatus) => eventParticipantStatus,
      identifier: "EventParticipants.eventParticipantStatus",
      width: "180px",
      sortable: true,
      cell: ({ EventParticipants }, index) => (
        <StyledCustomSelect
          isSearchable={false}
          onChange={(option) => {
            handleStatusChange(index, option);
          }}
          value={ATTENDANCE_STATUS_OPTIONS.find(
            (stat) =>
              stat?.value === EventParticipants[0].eventParticipantStatus
          )}
          options={getStatusOptions(
            EventParticipants[0].eventParticipantStatus
          )}
          styles={attendanceStatusSelectStyles}
          menuPortalTarget={document.body}
          getOptionLabel={(option) => {
            return option?.displayLabel;
          }}
          isDisabled={
            isRoleCongressman &&
            (EventParticipants[0].eventParticipantStatus === "Did Not Attend" ||
              EventParticipants[0].eventParticipantStatus === "Attended")
          }
        />
      ),
    },
    {
      name: "Remarks",
      selector: ({ remarks }) => remarks,
      identifier: "remarks",
      grow: 2,
      width: "170px",
      cell: ({ EventParticipants, id: rowId }) => (
        <CommentsContainer>
          {EventParticipants[0].hasComments === 1 &&
            hasPermission("comment-view") && (
              <ViewCommentBtn
                color="primary"
                size="sm"
                onClick={() => {
                  fetchComments(rowId);
                  setCommentId(rowId);
                  toggleModal();
                }}
              >
                {"View Comment"}
              </ViewCommentBtn>
            )}

          {EventParticipants[0].hasComments === 0 &&
            hasPermission("comment-create") && (
              <AddCommentBtn
                size="sm"
                onClick={() => {
                  setCommentId(rowId);
                  toggleModal();
                }}
              >
                {"Add Comment"}
              </AddCommentBtn>
            )}
        </CommentsContainer>
      ),
    },
    {
      name: "Actions",
      selector: (row) => row?.id,
      sortable: false,
      width: "120px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row, index) => (
        <>
          <StyledEyeIcon
            size={16}
            id={`view-row--${index}`}
            onClick={() => {
              navigate("/events/view", {
                state: {
                  row,
                  action: VIEW_ACTION,
                  repDetails: congDetails,
                  regionId: id,
                  congId: congID,
                },
              });
            }}
            color="#00316d"
          />
          <UncontrolledTooltip
            placement="auto"
            target={`view-row--${index}`}
          >
            {"View"}
          </UncontrolledTooltip>
        </>
      ),
    },
  ];
};

export default eventColumns;
